const $ = jQuery;

function setupHeaderColor() {
    const $blocks = $('.block-frontpage-hero');
    const $header = $('#header');
    const $btn = $('.header-button');

    if (!$blocks.length || !$header.length) {
        return;
    }

    const bgClass = $blocks.first().data('bg');

    if (bgClass) {
        $header.addClass(bgClass);

        if (bgClass === 'bg-fxd-purple') {
            $header.removeClass('text-black').addClass('text-white');
            $btn.removeClass('dark-btn-default').addClass('light-to-dark-btn');
        } else {
            $header.removeClass('text-white').addClass('text-black');
            $btn.removeClass('light-to-dark-btn').addClass('dark-btn-default');
        }
    }
}

export default {
    init() {
        setupHeaderColor();
        $(window).on('resize', setupHeaderColor);
    }
};
